import {Directive, EventEmitter, HostListener, Output} from '@angular/core';
import {ConfirmPopupComponent} from './confirm-popup.component';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[appOperationConfirm]',
})
export class OperationConfirmDirective {

  @Output()
  private appOperationConfirm: EventEmitter<any> = new EventEmitter<any>();

  constructor(private modalService: NgbModal) {
  }

  @HostListener('click')
  public onClick(): void {
    const options = { backdropClass: 'app-confirm-modal' } as NgbModalOptions;
    let popup = this.modalService.open(ConfirmPopupComponent, options);
    popup.componentInstance.title = 'confirm.title.operation';
    popup.componentInstance.message = 'confirm.message.operation';
    popup.result.then(
      () => this.appOperationConfirm.emit(),
      () => popup.close()
    );
  }

}
